import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuAltComponent } from './menu-alt.component';
import { WmTransitionModule } from '../transition/index';
import { WmIconModule } from '../icon/index';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [MenuAltComponent],
	imports: [CommonModule, WmTransitionModule, WmIconModule, RouterModule],
	exports: [MenuAltComponent]
})
export class WmMenuAltModule {}
